export function convertToNumber(value: string): number {
  return parseFloat(value.replace(/,/g, ''));
}

export function parseNaira(value: string): number {
  if (!value) return 0;
  const cleaned = value.replace(/[^0-9.]/g, ''); // Remove ₦, commas, etc.
  const parsed = parseFloat(cleaned);
  return isNaN(parsed) ? 0 : parsed;
}